<template>
  <v-card class="pa-3">
    <v-dialog
            v-model="dialog_bloqueo"
            persistent
            width="500"
    >
        <v-card class="elevation-0">
            <v-toolbar class="mb-0" dark color="success">
                <v-toolbar-title>
                    {{$t('aviso')}}
                </v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
                <h2>{{$t('msg_documentation_completed')}}</h2>
            </v-card-text>
        </v-card>
    </v-dialog>
    <v-card-title>Favor de subir nuevamente los documentos solicitados</v-card-title>
    <v-card-text>
      <v-divider class="my-3"></v-divider>

      <!-- Generar inputs según número de archivos-->
      <div v-for="(archivo, index) in archivos" :key="index" class="mb-3">
        <v-card flat class="pa-2">
          <div><strong>Archivo para: {{ documentationOptions[index].name }}</strong></div>
            <label><strong>Seleccionar archivos (PDF o Imagen, máx 2MB):</strong></label>
          <!-- Campo para seleccionar un archivo -->
          <input
            type="file"
            :accept="acceptedFileTypes"
            @change="onFileChange($event, index)"
          />

          <!-- Mostrar detalles -->
          <div v-if="archivo">
            <span v-if="archivo.error" class="red--text">
              {{ archivo.error }}
            </span>
            <span v-else>
              {{ archivo.file.name }} — {{ humanFileSize(archivo.file.size) }}
            </span>
          </div>       
        </v-card>
      </div>
    </v-card-text>

    <v-card-actions>
      <v-btn 
        :loading="loading"
        color="primary"
        :disabled="!puedeSubir" 
        @click="subirArchivos"
      >
        Subir archivos
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      loading: false,
      dialog_bloqueo: false,
      numArchivos: 0, // cantidad inicial
      archivos: [],   // arreglo con objetos { file, error }
      maxFileSize: 2 * 1024 * 1024, // 2MB
      acceptedFileTypes: '.pdf,image/*', // Tipos de archivo permitidos
      documentationOptions: [], // Tipos de documentación desde la API
      idInvitationByUser: -1
    };
  },
  mounted() {
    this.fetchDocumentationTypes()
    this.idInvitationByUser = this.$route.params['idInvitationByUser']
  },
  computed: {
    puedeSubir() {
      return this.archivos.length &&
             this.archivos.every(a => a && !a.error);
    }
  },
  methods: {
    async fetchDocumentationTypes() {
        console.log("Fetching documentation types...")
        const config = {
            method: 'get',
            url: 'https://empresa-service.intrare.app/get_documentation_to_correction_invitation_by_user/' + this.$route.params['idInvitationByUser'],
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': this.language,
            },
        };
        axios(config)
        .then(result => {
            this.documentationOptions = result.data
            this.numArchivos = result.data.length
            // Ajustar el arreglo según la cantidad de documentos
            const nuevoArr = []
            for (let i = 0; i < this.documentationOptions.length; i++) {
              nuevoArr.push( null)
            }
            this.archivos = nuevoArr
            if(result.data.length === 0){
                this.dialog_bloqueo = true
                console.log('Página Expirada .... overlay = ', this.dialog_bloqueo)
            }
            console.log(this.documentationOptions)
            console.log('Valor de archivos = ', this.archivos)
        })
        .catch(error => {
            console.log(error)
        })
    },
    onFileChange(e, index) {
      const file = e.target.files[0];
      const isValidType = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'].includes(file.type)

      if (!file) {
        this.$set(this.archivos, index, null);
        return;
      }

      let error = null;
      if (file.size > this.maxFileSize) {
        error = `El archivo supera los ${this.humanFileSize(this.maxFileSize)}`;
      } else if (!isValidType) {
        error = "El archivo debe ser PDF o imagen (JPEG/PNG).";
      }
      this.$set(this.archivos, index, { file, error });
    },
    humanFileSize(size) {
      if (size === 0) return "0 B";
      const i = Math.floor(Math.log(size) / Math.log(1024));
      const sizes = ["B", "KB", "MB", "GB"];
      return (size / Math.pow(1024, i)).toFixed(1) + " " + sizes[i];
    },
    async subirArchivos() {
      this.loading = true
      const formData = new FormData();
      formData.append('idInvitationByUser', this.idInvitationByUser);

      this.archivos.forEach((file, index) => {
        if (file) {
          formData.append('files', file.file)
          formData.append('documentation_ids', this.documentationOptions[index].id)
        }
      });
      const config = {
          method: 'post',
          url: 'https://empresa-service.intrare.app/update-documents-by-user/',
          headers: {
              'Content-Type': 'multipart/form-data',
              'Accept-Language': this.language,
          },
          data: formData
      };
      axios(config)
          .then(ok => {
            this.loading = false
            this.fetchDocumentationTypes()
            alert("Archivos subidos correctamente.")
          })
          .catch(error => {
          this.loading = false
          alert("Error de red o del servidor.")
          console.error(error)
        })
        .finally(() => (this.loading = false))
    }
  }
};
</script>
